<template>
  <div>
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <!-- Barra de informações da ligação -->

    <v-card class="d-inline-flex justify-space-around posicionamento" :class="`linha-total ${selectColor()}`" tile>
      <!-- Da esquerda para a direita, todos os espaçamentos horizontais são de ml-2. 
        O elemento que ocupar a última posição à direita precisa possuir um espaçamento de mx-2 ou ml-2 e mr-2.-->

      <div class="mt-3 ml-2 evitaQuebraDeLinha"><strong>Ramal: </strong> {{ ramalOperador() }}</div>

      <div v-show="exibeFila" class="mt-3 ml-2 evitaQuebraDeLinha"><strong v-show="exibeFila">Fila: </strong>
        {{ mostraFila() }}
      </div>

      <div class="mt-3 ml-2 evitaQuebraDeLinha"><strong>Tempo: </strong>{{ mostraTempo() }}</div>

      <div class="d-flex justify-space-between ml-2">
        <v-select dense style="min-width: 104px" outlined :items="pausas"
          :disabled="typeof agent !== 'undefined' && agent.paused === '1' ? true : false" v-model="pausa" label="Pausas"
          height="28" class="mt-1" background-color="background" light />

        <v-btn height="32" class="mt-2 ml-2" :dark="!disabledButton" color="bluePcm" :disabled="disabledButton"
          @click="pauseUnpauseMethod">
          {{ typeof agent !== 'undefined' && agent.paused === '1' ? 'Despausar' : 'Pausar' }}
        </v-btn>
      </div>

      <div class="d-flex justify-space-between ml-2" v-if="agent.channels.length === 0">
        <v-text-field v-show="agent.channels.length === 0" style="min-width: 104px" height="28" outlined
          background-color="background" light dense label="Número Ligação" class="mt-1" type="number"
          v-model="clickToCall" @keyup.enter.down="clickToCallMethod" />
        <v-btn v-show="agent.channels.length === 0" height="32" class="mt-2 mx-2" color="bluePcm" dark
          @click="clickToCallMethod">Ligar</v-btn>

      </div>

      <div class="line-number mr-2" v-show="agent.channels.length > 0">
        <v-btn icon small v-show="agent.channels.length > 1" @click="prevCallOperador(agent.deviceId)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <strong class="ml-2" style="white-space: pre-wrap">Número: </strong>
        {{ mostraLigacoes(agent.channels, agent.callIndexOperador) }}
        <v-btn icon small v-show="agent.channels.length > 1" @click="nextCallOperador(agent.deviceId)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>

      <div class="line-number mr-2" v-show="agent.channels.length > 0">
        <strong class="ml-2" style="white-space: pre-wrap">Protocolo: </strong>
        <div id="protocol" @change="agent.channels.length > 0">{{ mostrarProtocolo(agent.channels, agent.callIndexOperador) }}</div>
        <v-btn @click="copytext()" icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </div>

    </v-card>

  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import {
    registerVuexModule
  } from '@/utils/vuexUtils'
  import monitorScreen from '../store'

  import Snackbar from '@/componentes/Snackbar'
  import registerUserService from '@/utils/commomServices/registerUserService'
  import searchPermissionServices from '@/utils/commomServices/searchPermissionServices'

  import monitorScreenHttpServices from '../services/monitorScreenHttpServices'

  export default {
    name: 'MainScreenOperator',
    components: {
      Snackbar
    },
    props: {
      clickToCallNewNumberRequest: String,
    },
    data: () => ({
      form: {
        // Barra
        agente: '',
        action: 'login',
        ramal: '',
        realizouEvento: 'Operador',
      },
      text: '',
      snackbar: false,
      status: 'Pausado',
      pausaDescription: 'Pausa do Ramal',
      clickToCall: '',
      pausas: [],
      pausa: '',
      operador: '',
      disabledButton: false,
      filas: [],
      exibeFila: false,
      EndListAgent:false,
    }),

    computed: {
      ...mapGetters(['getRamais', 'getprotocoloChamadas', 'getEndListAgent']),
      ...mapGetters('monitorScreen', ['getFilas']),

      agent() {
        let agente = {}
        this.getRamais.forEach(ramal => {
          if (this.operador.length > 0 && typeof ramal.agent !== 'undefined') {
            if (ramal.agent.indexOf(`-${this.operador}`) > 0) {
              agente = Object.assign({}, ramal)
            }
          }
        })
        return agente
      },
      endListAgent(){
        if(this.getEndListAgent == true && this.EndListAgent == true){
          return true
        }else{
          return false
        }
      }
    },

    async created() {
      registerVuexModule(this.$store, 'monitorScreen', monitorScreen)
      this.operador = localStorage.getItem('operador_logado')
      const tokenOperador = localStorage.getItem('pcm_access_token_operador')

      if (this.operador && tokenOperador) {
        try {
          const response = await searchPermissionServices.getMe(tokenOperador)

          const permissionNames = response.data.permissions.map(permission => permission.name)
          if (permissionNames.includes(process.env.VUE_APP_CALLCENTER_OPERADOR)) {
            const responseVerificaLogin = await monitorScreenHttpServices.verificaLogin(this.operador)
            if (typeof responseVerificaLogin.data === 'string') {
              localStorage.removeItem('operador_logado')
              localStorage.removeItem('pcm_access_token_operador')
              this.$router.push({
                name: 'loginOperador'
              })
            }
          }
          const getFilas = await monitorScreenHttpServices.getFilas()
          this.filas = getFilas.data.map(fila => ({
            _id: fila._id,
            description: fila.description
          }))

          this.form.agente = this.operador

          const pausas = await monitorScreenHttpServices.getPausasOperador()

          this.pausas = pausas.data.map(pausa => ({
            text: pausa.description,
            value: pausa._id,
          }))

          if(this.pausas.length > 0){
            this.pausas = this.pausas.filter(( pausa ) => pausa.text !== 'autopause' );
          }

          if (this.agent.paused === '1') {
            const indexPausa = this.pausas.findIndex(pausaIndividual => pausaIndividual.text === this.agent.reason)

            if (indexPausa !== -1) {
              this.pausa = this.pausas[indexPausa].value
            }
          }

        } catch (err) {
          console.log(err, 'ERROR')
        }
      }
      this.EndListAgent = true;
    },

    methods: {
      ...mapActions(['prevCallOperador', 'nextCallOperador']),

      selectColor() {
        if (
          typeof this.agent.channels !== 'undefined' &&
          this.agent.channels.length > 0 &&
          this.agent.channels[this.agent.callIndex].state
        ) {
          if (
            this.agent.channels[this.agent.callIndex].state === 'RING' ||
            this.agent.channels[this.agent.callIndex].state === 'RINGING'
          ) {
            return 'operator-background-color-orange'
          } else if (this.agent.channels[this.agent.callIndex].state === 'UP') {
            return 'operator-background-color-red'
          }
          
        }

        if (this.agent.paused === '1') {
          return 'operator-background-color-yellow'
        }

        if(this.agent.isNotRegistered == true){
          return 'operator-background-color-gray'
        }

      
        return 'operator-background-color-green'
      },

      ramalOperador() {
        let operador = ''
        this.getRamais.forEach(ramal => {
          if (typeof ramal.agent !== 'undefined') {
            if (ramal.agent.indexOf(`-${this.operador}`) > 0) {
              operador = ramal.deviceId
            }
          }
        })
        return operador
      },

      // mostraFila(){
      //   console.log(this.filas)
      //   return this.agent
      // },

      mostraFila() {
        let key = this.agent.callIndex

        if (this.agent.channels && typeof this.agent.channels[key] !== 'undefined' && this.agent.channels[key].io ===
          'incoming') {
          let queueByCall = ''
          this.exibeFila = true
          if (this.filas && this.agent.queueEnters[key]) {
            const indexQueue = this.filas.findIndex(queue => queue._id === this.agent.queueEnters[key].queue)
            if (indexQueue !== -1) {
              queueByCall = this.filas[indexQueue].description
              if (queueByCall.length > 10) {
                return this.limitaNumeroDeCaracteresQueue(queueByCall)
              }
              return queueByCall
            }
          }
          return 'D'
        }
        this.exibeFila = false
        return "---"
      },

      limitaNumeroDeCaracteresQueue(queue) {
        if (queue.length > 22 && window.innerWidth > 1200) {
          let arrayQueue = queue.split('')
          arrayQueue.splice(22)
          arrayQueue.push('...')
          let nomeQueueAlterado = arrayQueue.join('')
          return nomeQueueAlterado
        } else if (queue.length > 10 && window.innerWidth <= 1200) {
          let arrayQueue = queue.split('')
          arrayQueue.splice(10)
          arrayQueue.push('...')
          let nomeQueueAlterado = arrayQueue.join('')
          return nomeQueueAlterado
        }

        return queue
      },

      mostraTempo() {
        if (typeof this.agent.channels !== 'undefined' && this.agent.channels.length === 0) {
          return this.agent.time
        }
        return this.agent.channels[this.agent.callIndexOperador].time
      },

      mostraLigacoes(arrayLigacoes, index) {
        if (arrayLigacoes.length > 0) {
          return arrayLigacoes[index].phoneNumber
        }
        return ''
      },

      mostrarProtocolo(arrayLigacoes, index) {
        if (arrayLigacoes.length > 0) {
          const indexProtocolo = this.getprotocoloChamadas.findIndex(protocolo => arrayLigacoes[index].linkedId_uniqueId
            .split('_')[0] == protocolo.uniqueId && arrayLigacoes[index].linkedId_uniqueId.split('_')[0] == protocolo
            .linkedId)
          if (indexProtocolo >= 0) {
            let protocolos = JSON.parse(this.getprotocoloChamadas[indexProtocolo].protocolos)
            return protocolos[0]
          }
        }
      },

      copytext() {
        navigator.clipboard.writeText(document.getElementById('protocol').textContent);
      },

      async clickToCallMethod() {
        console.log('inicio click to call')

        this.snackbar = false
        if (this.clickToCall === '') {
          this.text = 'Favor digitar um número para realizar a ligação'
          this.snackbar = true
        }
        const clickToCallForm = {
          endpoint: this.ramalOperador(),
          destino: this.clickToCall,
        }
        console.log(clickToCallForm, 'formulario click to call')
        await monitorScreenHttpServices.clickToCallMethod(clickToCallForm)
        console.log('Executou a requisicao click to call')
      },

      async pauseUnpauseMethod() {
        console.log('inicio pause/unpause method')
        this.disabledButton = true
        let data
        this.snackbar = false
        if (typeof this.agent !== 'undefined' && (!this.agent.paused || this.agent.paused === '0')) {
          if (this.pausa === '') {
            this.text = 'Favor escolher o motivo da pausa.'
            this.snackbar = true
            this.disabledButton = false
            return
          }
          data = {
            agente: this.operador,
            action: 'pause',
            pause_id: this.pausa,
            realizouEvento: 'Operador'
          }
        } else {
          data = {
            agente: this.operador,
            action: 'unpause',
            realizouEvento: 'Operador'
          }
          this.pausa = ''
        }

        console.log(data, 'formulario pause/unpause method.')
        await monitorScreenHttpServices.acoesOperador(data)
        this.disabledButton = false
        console.log('Executou a requisicao pause/unpause method')
      },

      async forcedOperadorLogout() {
        await registerUserService.loginOperador({
          action: 'logout',
          realizouEvento: 'Operador',
          agente: localStorage.getItem('operador_logado'),
        })
        localStorage.removeItem('pcm_access_token_operador')
        localStorage.removeItem('operador_logado')

        this.$router.push({
          name: 'loginOperador'
        })
      },
    },

    watch: {
      clickToCallNewNumberRequest: function (newNumber, ) {
        this.clickToCall = newNumber
      },
      agent: {
        deep: true,
        async handler(novo, antigo) {
          if (novo.paused !== antigo.paused && this.pausas) {
            this.pausas.forEach(pausaIndividual => {
              if (this.agent.reason === pausaIndividual.text && this.pausa !== pausaIndividual.value) {
                this.pausa = pausaIndividual.value
              }
            })
          }
          if (
            (Object.keys(novo).length === 0  && this.endListAgent == true) ||
            (typeof novo.agent === 'undefined' && typeof antigo.agent !== 'undefined') ||
            novo.arrayQueues.length === 0 ||
            (novo.arrayQueues && antigo.arrayQueues && novo.arrayQueues.length < antigo.arrayQueues.length)
          ) {
            await this.forcedOperadorLogout()
          }
        },
      },
    },
  }
</script>

<style scoped>
  /* Barra com dados da chamada */
  .linha-total {
    width: 100vw;
    height: 52px;
    padding-top: 2px;
  }

  .evitaQuebraDeLinha {
    white-space: nowrap;
  }

  .line-number {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 3px;
  }

  .operator-background-color-green {
    background-color: #3A811D;
    color: white;
  }

  .operator-background-color-yellow {
    background-color: #FBC400;
    
  }

  .operator-background-color-orange {
    background-color: var(--v-orangePcm-base);
  }

  .operator-background-color-red {
    background-color: var(--v-darkRed-base);
  }
  .operator-background-color-gray {
    background-color: var(--v-gray-base);
    color: white;
  }

  .posicionamento {
    z-index: 3;
  }

  /* Fim da barra com dados da chamada */

</style>